import { KYMW0500Model } from '../kymw0500.model';
import { RegistRelatedDataModel } from '../vo/regist-related-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 入力した紐付設定情報をDBに反映する
 *
 * @export API通信成功時の処理
 * @class RegistRelatedDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistRelatedDataService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW0500Model;
  private vo: RegistRelatedDataModel;
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteUserService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        RelatedDataList: {
          condition: {
            ProcessDiv: this.vo.processDiv,
            ProcessMode: this.vo.processMode,
            OrderCode: this.vo.orderCode,
            MainPCode: this.vo.mainPCode
          },
          combination: this.vo.relatedDataList.map(relatedData => {
            return {
              condition: {
                PCode: relatedData.pCode,
                SelectedIB: relatedData.selectedIB,
                SelectedTO: relatedData.selectedTO,
                SelectedGU: relatedData.selectedGU,
                SelectedTI: relatedData.selectedTI,
                SelectedSA: relatedData.selectedSA,
                SelectedTK: relatedData.selectedTK,
                SelectedNA: relatedData.selectedNA,
                SelectedNI: relatedData.selectedNI,
                SelectedKU: relatedData.selectedKU,
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW0500Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof DeleteUserService
   */
  execute(model: KYMW0500Model, vo: RegistRelatedDataModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.send('registRelatedData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteUserService
   */
  success(data: any) {
    // 『紐付設定』画面を終了する
    this.model.kymw0500Component.eventBtnClose_CLICKHandler();
  }
}

